// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"320":"forum/pages/BlogComposer","786":"forum/components/Modals/RenameArticleModal","851":"forum/components/Modals/BlogPostSettingsModal"}[chunkId] + ".js";
};